import GoogleButton from "@ui/Button/GoogleButton.vue";
import Button from "@ui/Button/index.vue";
import Container from "@ui/layout/Container.vue";
import Text from "@ui/Text/index.vue";

import {
  FontIcon,
  IconifyIconOffline,
  IconifyIconOnline
} from "@/components/ReIcon";
import YIcon from "@/components/YIcon/index.vue";

import PageContainer from "../layout/Page.vue";

export const useComponents = app => {
  app.component("IconifyIconOffline", IconifyIconOffline);
  app.component("IconifyIconOnline", IconifyIconOnline);
  app.component("FontIcon", FontIcon);
  app.component("YButton", Button);
  app.component("YText", Text);
  app.component("YIcon", YIcon);
  app.component("YContainer", Container);
  app.component("PageContainer", PageContainer);
  app.component("YGoogleButton", GoogleButton);
};
